/**
 * Every campaign type, in the order the create (`NewCampaign/Steps/Details/DetailsStep.tsx`) and
 * edit (`CampaignOverviewPage/CampaignOverviewEdit.tsx`) forms offer them. `Campaign['type']` is a
 * plain string: a type missing here opens the edit form blank, and the next save changes it. Each
 * has its label at `Models.Campaign.type.<type>` in en.ts.
 */
export const CAMPAIGN_TYPES = [
    'linear',
    'vistar_us',
    'vistar_us2',
    'vistar_uk',
    'hivestack_us',
    'hivestack_uk',
    'placeexchange_us',
] as const;

export type CampaignType = (typeof CAMPAIGN_TYPES)[number];

export const campaignTypeLabel = (type: CampaignType) => `Models.Campaign.type.${type}` as const;
